import { Screen, SecondaryButton, Title } from './kit';
import { POLICY } from './policyText';

/** Политика обработки данных.
 *
 *  Артефакт репозитория, а не ссылка наружу: текст, на который ссылается
 *  согласие при регистрации, обязан быть доступен без сети и обязан
 *  меняться вместе с кодом, который он описывает. */
export function PolicyScreen({ onBack }: { onBack: () => void }) {
  return (
    <Screen>
      <Title>{POLICY.title}</Title>
      <p className="m-0 text-[0.85rem] text-muted">Редакция от {POLICY.updated}</p>
      {POLICY.sections.map((section) => (
        <section key={section.heading} className="flex flex-col gap-2">
          <h2 className="m-0 text-lg font-semibold">{section.heading}</h2>
          {section.paragraphs.map((text) => (
            <p key={text.slice(0, 24)} className="m-0 text-[0.95rem] text-ink">
              {text}
            </p>
          ))}
        </section>
      ))}
      <SecondaryButton bottom onClick={onBack}>
        Назад
      </SecondaryButton>
    </Screen>
  );
}
